import _ from 'underscore';
const highestOrder = nodes => {
  let highest = 0;
  if (nodes.length && nodes.length > 0) {
    nodes.forEach(node => {
      let localMax = highestOrder(node.nodes);
      if (localMax < node.sortOrder) {
        localMax = node.sortOrder;
      }
      if (localMax > highest) {
        highest = localMax;
      }
    });
  }
  return highest;
};

/**
 * Preforms a depth first search of the tree structure
 * to find a node.
 * @param {String} id - id of the node to find
 * @param {Object} root - the root of the tree to traverse
 * @param {Array} root.nodes - list of subnodes for a root
 */
const findNode = (id, root) => {
  if (root.id === id) {
    return root;
  }
  let found;
  root.nodes.some(node => {
    found = findNode(id, node);
    return typeof found !== 'undefined';
  });
  return found;
};
const findParent = (id, root) => {
  if (root.nodes && root.nodes.some(node => node.id === id)) {
    return root;
  }
  let found;
  root.nodes.some(node => {
    found = findParent(id, node);
    return typeof found !== 'undefined';
  });
  return found;
};
const insertNodeHelper = (siblingNodes, incomingNode, index) => {
  const newNode = incomingNode;
  // we should always have sibing nodes...
  if (siblingNodes && siblingNodes.length > 0) {
    const firstNode = siblingNodes[0];
    const orderedNodes = _.sortBy(siblingNodes, 'sortOrder');
    newNode.parentID = firstNode.parentID;
    newNode.sortOrder = index;
    const saveNodes = [newNode];
    for (let i = 0; i < siblingNodes.length; i += 1) {
      // on first node, store that sortOrder

      const node = orderedNodes[i];
      if (node.id !== newNode.id) {
        node.sortOrder = i;
        if (i < index) {
          node.sortOrder = i;
        } else {
          node.sortOrder = i + 1;
        }
        saveNodes.push(node);
      }
    }
    return saveNodes;
  }
  return [];
};
const moveNodes = (orgFromNode, orgToNode, index, list) => {
  const copy = obj => JSON.parse(JSON.stringify(obj));
  const fromNode = copy(orgFromNode);
  const toNode = copy(orgToNode);
  if (fromNode.id !== toNode.id) {
    // then we are not moving over the same node...
    const root = {
      id: null,
      nodes: copy(list)
    };
    const parent = findNode(toNode.parentID, root);
    let siblingNodes = root.nodes;
    if (parent && !_.isNull(toNode.parentID)) {
      // toNode is a top node.
      siblingNodes = parent.nodes;
    }
    return insertNodeHelper(siblingNodes, fromNode, index);
  }
  return [];
};
export { findParent, highestOrder, findNode, moveNodes };